import ScaleBar from '@arcgis/core/widgets/ScaleBar.js';
import Compass from '@arcgis/core/widgets/Compass.js';
import type MapView from '@arcgis/core/views/MapView.js';

export function registerStandardWidgets(view: MapView): void {
  view.ui.add(new ScaleBar({ view, unit: 'metric' }), 'bottom-left');
  view.ui.add(new Compass({ view }), 'top-left');

  view.ui.move('zoom', 'top-left');
}
